import { ToastProvider } from "@/ds";
import { useControlPanel } from "./use-control-panel";
import { ControlPanelView } from "./view-control-panel";

/** Liga o ViewModel à View da casca; o `ToastProvider` é o host único dos toasts das quatro abas e dos cartões de usuário. */
export function ControlPanelScreen() {
  const vm = useControlPanel();

  return (
    <ToastProvider position="top-right">
      <ControlPanelView {...vm} />
    </ToastProvider>
  );
}

export type * from "./types-control-panel";
